import ApplicationController from '@app/javascript/controllers/application_controller'
import { useBusItem } from '@app/javascript/controllers/mixins/useBusItem.js'

export class Controller extends ApplicationController {
  static targets = [
    'saveChangesButton',
    'saveChangesCriteria'
  ]

  doConnect() {
    useBusItem(this, { addToBus: false })
  }

  onFiltersChanged(_ev) {
    this.saveChangesButtonTarget.disabled = false
  }

  onKeywordsChanged(ev) {
    const value = ev.currentTarget.value.trim()

    this.saveChangesButtonTarget.disabled = !value
  }

  prepareChanges(ev) {
    this.saveChangesCriteriaTarget.value = JSON.stringify(this.currentSearchCriteria)
  }

  get currentSearchCriteria() {
    return this.getBusItem('search-v2--container').serializeSearchForms()
  }
}
